<div>
  <div class="loader-bg col-12" *ngIf="showLoader">
    <span class="loader"><span class="loader-inner"></span></span>
  </div>

  <div class="modal-header col-12">
    <img title="Close Modal" (click)="closeModal()" width="17" height="17" src="assets/images/cross-dark-grey.svg">
  </div>
  <div class="modal-body">
    <h2 class="modal-title col-12">Welcome Back</h2>

    <p class="error-message" *ngIf="showErrorMsg">Incorrect password or email. Please try again</p>
    <form class="form-bg col-12" [formGroup]="loginForm">
      <div class="form-group">
        <label for="email" [ngClass]="{'error-text-color' : showErrorMsg}">Your Email</label>
        <input type="email" name="email" class="form-control" #email required id="email" formControlName="email" [ngClass]="{'error-border-color' : showErrorMsg}" autocomplete="off" (blur)="emailValidation()" (focus)="showEmailError = false;">
        <small *ngIf="loginForm.get('email').invalid && (loginForm.get('email').dirty || loginForm.get('email').touched)" class="error-text-color">
          <span *ngIf="loginForm.controls['email'].errors.required">
            Email is required.
          </span>
        </small>
        <small *ngIf="showEmailError" class="error-text-color">
          Invalid email address.
        </small>
      </div>
      <div class="form-group">
        <label for="password" [ngClass]="{'error-text-color' : showErrorMsg}">Password</label>
        <input type="password" name="password" class="form-control" #password required id="password" minlength="8" maxlength="20" formControlName="password" [ngClass]="{'error-border-color' : showErrorMsg}" autocomplete="off">
        <small *ngIf="loginForm.get('password').invalid && (loginForm.get('password').dirty || loginForm.get('password').touched)" class="error-text-color">
          <span *ngIf="loginForm.controls['password'].errors.required">
            Password is required.
          </span>
          <span *ngIf="loginForm.controls['password'].hasError('minlength')">
            Password min length is 8 characters.
          </span>
        </small>
      </div>
      <div class="form-check pl-0">
        <label (click)="forgotPwdModal()">Forgot Password?</label>
      </div>
      <div class="btn-bg mt-4">
        <button type="submit" class="btn-green col-10" [disabled]="loginForm.invalid" (click)="loginFun()" [ngClass]="{'btn-green-disabled' : loginForm.invalid}">log in</button>
      </div>
    </form>

    <div class="separator-bg">
      <p class="separator-text">Don’t have an account?</p>
    </div>
    <div class="btn-bg mt-5">
      <button type="submit" class="btn-green-bordered col-10" (click)="openSignUpModal()">Create Account here</button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/modules/user/auth/login/login.component.html